export default __webpack_public_path__ + "static/media/backgroundLogoAcium.9dbb5dae.svg";